// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `::ng-deep app-personal-certificate {
   display: block;
   width: 312px;
}

mat-icon {
   width: 32px;
   height: 32px;
   line-height: 32px;
   padding: 4px;
   text-align: center;
   position: absolute;
   right: 0;
}

::ng-deep .mat-button:hover .mat-button-focus-overlay {
   opacity: 0.04 !important;
}


.mat-icon-button {
   padding: 0;
   min-width: 0;
   width: 40px;
   height: 50px;
   flex-shrink: 0;
   line-height: 40px;
   border-radius: 50%;
}

.field-desc{
   height: 20px;
}`, "",{"version":3,"sources":["webpack://./src/app/account/personal-certificate/personal-certificate.component.css"],"names":[],"mappings":"AAAA;GACG,cAAc;GACd,YAAY;AACf;;AAEA;GACG,WAAW;GACX,YAAY;GACZ,iBAAiB;GACjB,YAAY;GACZ,kBAAkB;GAClB,kBAAkB;GAClB,QAAQ;AACX;;AAEA;GACG,wBAAwB;AAC3B;;;AAGA;GACG,UAAU;GACV,YAAY;GACZ,WAAW;GACX,YAAY;GACZ,cAAc;GACd,iBAAiB;GACjB,kBAAkB;AACrB;;AAEA;GACG,YAAY;AACf","sourcesContent":["::ng-deep app-personal-certificate {\n   display: block;\n   width: 312px;\n}\n\nmat-icon {\n   width: 32px;\n   height: 32px;\n   line-height: 32px;\n   padding: 4px;\n   text-align: center;\n   position: absolute;\n   right: 0;\n}\n\n::ng-deep .mat-button:hover .mat-button-focus-overlay {\n   opacity: 0.04 !important;\n}\n\n\n.mat-icon-button {\n   padding: 0;\n   min-width: 0;\n   width: 40px;\n   height: 50px;\n   flex-shrink: 0;\n   line-height: 40px;\n   border-radius: 50%;\n}\n\n.field-desc{\n   height: 20px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
